import ying from '../../../assets/images/production/yingSeries/ying.png'
import leftBall from '../../../assets/images/production/yingSeries/left-ball.png'

import styles from './style.module.scss'

function YingSeries() {
    return (
        <div className={`production-series-wrapper ${styles['ying-series-wrapper']}`}>
            <div className={`banner ${styles['banner']}`}>
                <div className="title">电子取证产品</div>
                <div className="content">构建多源数据采集接入能力、贴合业务场景的取证分析能力，打造了“多场景、多形态、高性能、高产出” 的电子取证产品体系，满足现场勘查、终端取证、证据分析、电子物证实验室等各类业务场景。</div>
            </div>
            <div className={`series-container ${styles['series-container']}`}>
                <div className={`series-content ${styles['series-content']}`}>
                    <img src={leftBall} alt="" />
                    <div>
                        <div className={styles['series-left']}>
                            <div className={`introduction-title ${styles['introduction-title']}`}>
                                <p><span>“鹰”系列</span><span>—— 实现电子数据提取、固定、生成报告的闭环</span></p>
                                <p>该系列产品是一款集电子数据证据的提取、解析、固定、分析、展示、报告生成为一体的取证产品，可应用于基层执法人员现场勘验及计算机取证实验室的检验鉴定等不同应用场景。</p>
                            </div>
                            <div className={styles['introduction-container']}>
                                <div className={`introduction-item ${styles['introduction-item']}`}>
                                    <div className={styles['img']}></div>
                                    <div className={styles['introduction-content']}>
                                        <p>支持便携式和塔机形态</p>
                                    </div>
                                </div>
                                <div className={`introduction-item ${styles['introduction-item']}`}>
                                    <div className={styles['img']}></div>
                                    <div className={styles['introduction-content']}>
                                        <p>高质量恢复苹果IOS系统的应用删除数据</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className={styles['series-right']}>
                            <img src={ying} alt="" />
                        </div>
                    </div>
                </div>

            </div>
        </div>
    )
}

export default YingSeries